import React from 'react'

import { FormInput } from '../../Form/Input'
import { NewItem, Desc, Reward, Name, Trash } from '../../ListItem'

function NewChallenge (props){
  return (
    <NewItem>
      <Name>
        <FormInput width={ '90%' } name={ 'name' } onChange={ props.onChange } value={ props.challengeName } />
      </Name>
      
      <Desc>
        <FormInput width={ '90%' } name={ 'desc' } onChange={ props.onChange } value={ props.desc } />
      </Desc>

      <Reward>
        <FormInput width={ '90%' } center={'true'} name={ 'reward' } onChange={ props.onChange } value={ props.reward } />
      </Reward>

      <Trash onClick={ props.delete }></Trash>
    </NewItem>
  )
}

export default NewChallenge